<ion-content>
  <ion-grid *ngIf="!teamType">

    <ion-row>
      <ion-col size="10" class="parameters-col">
        <div class="parameters">
          <ion-label >{{'TREASURE_HUNT.PARAMETERS'|translate}}</ion-label>
        </div>
        
      </ion-col>
      <ion-col size="2" class="parameters-col">
        <div class="close-div">
          <ion-icon name="close" class="div_dismiss" (click)="dismiss()"></ion-icon>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="parameters-col">
        <form class="div_form" [formGroup]="SiteDetailsForm">
          <formly-form [model]="model" [fields]="fields" [options]="options" [form]="SiteDetailsForm"></formly-form>
        </form>
      </ion-col>
      
    </ion-row>

    <ion-row>
      <ion-col class="parameters-col">
        <div class="div_update">
          <ion-button [disabled]="!SiteDetailsForm.valid" (click)="update()" shape="round" class="btn_text">{{'TREASURE_HUNT.ACCEPT_HUNT'|translate}}</ion-button>
      
        </div>
         
      </ion-col>
    </ion-row>
  </ion-grid>
 
  <ion-grid *ngIf="teamType=='Production'" class="grid">
    <ion-row>
      <ion-col>
        <div class="close-div">
          <ion-icon name="close" class="div_dismiss" (click)="dismiss()"></ion-icon>
        </div>
      </ion-col>
    </ion-row>
    <ion-row >
      <ion-col>
        <ion-label class="popup-header">
          {{'ACCEPT_HUNT_PAGE.YOU_HAVE_SELECTED'|translate}} <b>{{message}}</b>. 
          {{'ACCEPT_HUNT_PAGE.CHALLENGES_THAT_WOULD_APPEAR_TREASUREHUNT_ARE'|translate}}  
        </ion-label>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-label class="popup-list destination_name_label">1. {{'LIGHTINIG_TITLE'|translate}}</ion-label>
        <ion-label class="popup-list destination_name_label">2. {{'PROCESS_OPTIMIZATION'|translate}}</ion-label>
        <ion-label class="popup-list destination_name_label">3. {{'COMPRESSED_AIR_TITLE'|translate}}</ion-label>
        <ion-label class="popup-list destination_name_label">4. {{'MOTOR_TITLE'|translate}}</ion-label>
        <ion-label class="popup-list destination_name_label">5. {{'HVAC_TITLE'|translate}}</ion-label>
        <ion-label class="popup-list destination_name_label">6. {{'TREASURE_HUNT.BONUS_QUESTIONS'|translate}}</ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid *ngIf="teamType=='Head Office'" class="grid">
    <ion-row>
      <ion-col>
        <div class="close-div">
          <ion-icon name="close" class="div_dismiss" (click)="dismiss()"></ion-icon>
        </div>
      </ion-col>
    </ion-row>
    <ion-row >
      <ion-col>
        <ion-label class="popup-header">
          {{'ACCEPT_HUNT_PAGE.YOU_HAVE_SELECTED'|translate}} <b>{{message}}</b>. 
          {{'ACCEPT_HUNT_PAGE.CHALLENGES_THAT_WOULD_APPEAR_TREASUREHUNT_ARE'|translate}}  
        </ion-label>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-label class="popup-list destination_name_label">1. {{'LIGHTINIG_TITLE'|translate}}</ion-label>
        <ion-label class="popup-list destination_name_label">2. {{'APPLIANCES_TITLE'|translate}}</ion-label>
        <ion-label class="popup-list destination_name_label">3. {{'HVAC_TITLE'|translate}}</ion-label>
        <ion-label class="popup-list destination_name_label">4. {{'INSULATION_TITLE'|translate}}</ion-label>
        <ion-label class="popup-list destination_name_label">5. {{'TREASURE_HUNT.BONUS_QUESTIONS'|translate}}</ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>